import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import Stats from "../components/stats"
import { SRLWrapper } from "simple-react-lightbox";

import { Link } from "gatsby"

const TextSection = props => {

  return (
    <section className={props.className} id={props.id}>
      
      {props.header ? <h1 className="title-header">{props.header}</h1> : null}
      {props.subHeader ? (
        <h2 className="subtitle-header">{props.subHeader}</h2>
      ) : null}

<SRLWrapper className="hello">

      {props.children ? (
        <div className="text-container">
          {props.children}
          {props.link ? <Link to={`${props.link}`}>LES MER</Link> : null}
        </div>
        
      ) : null}
      {props.image ? <Img Tab="img" fixed={props.image} /> : null}

      {props.imgFluid ? ( <Img Tab="img" className="img-fluid" fluid={props.imgFluid} /> ) : null}
      </SRLWrapper>
      {props.stats ? <Stats /> : null}
      {props.iframe ? (
        <>
        <div>
        <iframe
          title="google maps"
          src="https://www.google.com/maps/d/embed?mid=1eRBJ6tKfnxDYtRvfjY0oAXK7JmiJJq7E"
          width="640"
          height="480"
        ></iframe>
        <span className="iframe-desc">Naviger i kartet for å se opplæring i skoler, kommuner og fylker i utrullingsperioden</span>
        </div>
        </>
      ) : null}

    </section>
  )
}

// flex-direction: optional row-style
const StyledTextSectionClean = styled(TextSection)`
  
    min-height: ${props => (props.fullWidth ? "90vh" : "")};
    padding: 10vh 0;
    justify-content: space-evenly;
    align-items: end;
    flex-direction: ${props => (props.reverse ? "row" : "row-reverse")};
    flex-wrap: wrap-reverse;
    display:flex;
    width: 100%;

    
    div:last-of-type {
      ${props => (props.imgFluid ? "display:flex;width: 100%;justify-content: space-evenly;flex-wrap: wrap-reverse;align-items: end;" : "")}
    }

  
  a {
    padding: 7px 15px;
    border: 2px solid #00679b;
    border-radius: 15px;
    colo  r: #00679b;
    text-decoration: none;
    font-size: 0.9rem;
  }

  .img-fluid {
    width: 100%;
    max-width: ${props => props.maxWidth};
  }

  iframe {
    align-self: flex-end;
    max-width: 80vw;
    display: flex;
  }

  @media (min-width: 1100px) {
    iframe {
      max-width: 50vw;
    }
  }

  .gatsby-image-wrapper {
    align-self: flex-end;
  }

  a:hover,
  a:focus {
    background-color: #00679b;
    color: #fff;
  }

  .title-header {
    order: 1;
    width: 100%;
    text-align: center;
    align-self: flex-start;
    margin-bottom: 25px;
    font-size: 2rem;
  }

  h1 {
    color: #00679b;
    font-size: 2rem;
    margin-bottom: 10px;
  }

  h2 {
    color: #78b6e3;
    margin-bottom: 10px;
    font-size: 1.4rem;
  }

  .text-container {
    padding: 0 20px;
    max-width: 50vw;
  }

  .text-container,
  .text-container li {
    max-width: 700px;
    font-size: 20px;
  }

  @media (min-width: 1080px) {
    flex-direction: ${props => (props.reverse ? "row-reverse" : "row")};
  }

  @media (max-width: 1200px) {
    flex-direction: coloum;
    div {
      max-width: 80vw;
    }
    h1 {
      margin-top: 15px;
    }
  }
`

export default StyledTextSectionClean
